import React from 'react';
import { useAccountCrumbs } from '@thd-olt-component-react/customer-account-navigation';
import { Metadata } from '@thd-olt-component-react/metadata';
import { ReturnForm } from '../components/ReturnForm';
import { PageLayout } from '../components/shared/PageLayout';
import { useReturnStore } from '../stores/returnStore';

interface ReturnsProps {
  customerType: string;
  customerRole: string;
}

export const Returns = ({ customerRole, customerType }: ReturnsProps) => {
  const isMilitaryExchangeGuest = useReturnStore(
    (state) => state.isMilitaryExchangeGuest,
  );
  const orderDetailsPath = useReturnStore((state) => state.orderDetailsPath);
  const nonGuestCrumbs = [
    {
      path: '/myaccount/purchase-history',
      label: 'Purchase History',
    },
    {
      path: orderDetailsPath,
      label: 'Order Details',
    },
    {
      label: 'Return Items',
      path: '/myaccount/start-a-return',
    },
  ];
  const guestCrumbs = [
    {
      path: '/myaccount/guest-order-tracking',
      label: 'Track Your Order',
    },
    {
      label: 'Return Items',
      path: '/myaccount/start-a-return',
    },
  ];
  const crumbs = useAccountCrumbs(
    isMilitaryExchangeGuest ? guestCrumbs : nonGuestCrumbs,
  );

  return (
    <PageLayout
      crumbs={crumbs}
      customerRole={customerRole}
      customerType={customerType}
      pageTitle="Return Items"
    >
      <>
        <Metadata title="The Home Depot" />
        <div className="sui-max-w-xl">
          <ReturnForm />
        </div>
      </>
    </PageLayout>
  );
};

Returns.displayName = 'Returns';
